// extracted by mini-css-extract-plugin
export default {"signupDetailsForm":"SignupDetailsForm_signupDetailsForm__aWpjq","row":"SignupDetailsForm_row__m0eo7","sumbitButton":"SignupDetailsForm_sumbitButton__79VCL"};